export default {
  LOADING_GET_DERIVATIVES: 'LOADING_GET_DERIVATIVES',
  SUCCESS_GET_DERIVATIVES: 'SUCCESS_GET_DERIVATIVES',
  ERROR_GET_DERIVATIVES: 'ERROR_GET_DERIVATIVES',

  LOADING_GET_DERIVATIVE_INFO: 'LOADING_GET_DERIVATIVE_INFO',
  SUCCESS_GET_DERIVATIVE_INFO: 'SUCCESS_GET_DERIVATIVE_INFO',
  ERROR_GET_DERIVATIVE_INFO: 'ERROR_GET_DERIVATIVE_INFO',

  REFRESH_GET_DERIVATIVE_INFO: 'REFRESH_GET_DERIVATIVE_INFO',

  LOADING_GET_DERIVATIVES_GROUPS: 'LOADING_GET_DERIVATIVES_GROUPS',
  SUCCESS_GET_DERIVATIVES_GROUPS: 'SUCCESS_GET_DERIVATIVES_GROUPS',
  ERROR_GET_DERIVATIVES_GROUPS: 'ERROR_GET_DERIVATIVES_GROUPS',

  LOADING_GET_FAVORITE_DERIVATIVES: 'LOADING_GET_FAVORITE_DERIVATIVES',
  SUCCESS_GET_FAVORITE_DERIVATIVES: 'SUCCESS_GET_FAVORITE_DERIVATIVES',
  ERROR_GET_FAVORITE_DERIVATIVES: 'ERROR_GET_FAVORITE_DERIVATIVES',

  LOADING_SET_FAVORITE_DERIVATIVES: 'LOADING_SET_FAVORITE_DERIVATIVES',
  SUCCESS_SET_FAVORITE_DERIVATIVES: 'SUCCESS_SET_FAVORITE_DERIVATIVES',
  ERROR_SET_FAVORITE_DERIVATIVES: 'ERROR_SET_FAVORITE_DERIVATIVES',

  LOADING_GET_DERIVATIVES_TREND: 'LOADING_GET_DERIVATIVES_TREND',
  SUCCESS_GET_DERIVATIVES_TREND: 'SUCCESS_GET_DERIVATIVES_TREND',
  ERROR_GET_DERIVATIVES_TREND: 'ERROR_GET_DERIVATIVES_TREND',

  LOADING_GET_DERIVATIVES_ORDERS: 'LOADING_GET_DERIVATIVES_ORDERS',
  SUCCESS_GET_DERIVATIVES_ORDERS: 'SUCCESS_GET_DERIVATIVES_ORDERS',
  ERROR_GET_DERIVATIVES_ORDERS: 'ERROR_GET_DERIVATIVES_ORDERS',

  LOADING_GET_DERIVATIVES_CLOSED_ORDERS: 'LOADING_GET_DERIVATIVES_CLOSED_ORDERS',
  SUCCESS_GET_DERIVATIVES_CLOSED_ORDERS: 'SUCCESS_GET_DERIVATIVES_CLOSED_ORDERS',
  ERROR_GET_DERIVATIVES_CLOSED_ORDERS: 'ERROR_GET_DERIVATIVES_CLOSED_ORDERS',

  LOADING_DELETE_DERIVATIVES_ORDERS: 'LOADING_DELETE_DERIVATIVES_ORDERS',
  SUCCESS_DELETE_DERIVATIVES_ORDERS: 'SUCCESS_DELETE_DERIVATIVES_ORDERS',
  ERROR_DELETE_DERIVATIVES_ORDERS: 'ERROR_DELETE_DERIVATIVES_ORDERS',

  LOADING_GET_DERIVATIVES_POSITIONS: 'LOADING_GET_DERIVATIVES_POSITIONS',
  SUCCESS_GET_DERIVATIVES_POSITIONS: 'SUCCESS_GET_DERIVATIVES_POSITIONS',
  ERROR_GET_DERIVATIVES_POSITIONS: 'ERROR_GET_DERIVATIVES_POSITIONS',

  LOADING_GET_DERIVATIVES_HISTORY: 'LOADING_GET_DERIVATIVES_HISTORY',
  SUCCESS_GET_DERIVATIVES_HISTORY: 'SUCCESS_GET_DERIVATIVES_HISTORY',
  ERROR_GET_DERIVATIVES_HISTORY: 'ERROR_GET_DERIVATIVES_HISTORY',

  SIGNALR_INCOME_RECEIVE_DERIVATIVE_ORDER_UPDATED: 'SIGNALR_INCOME/derivatives-order-updated',

  SIGNALR_INCOME_RECEIVE_DERIVATIVE_ORDER_OPENED: 'SIGNALR_INCOME/derivatives-order-opened',
  SIGNALR_INCOME_RECEIVE_DERIVATIVE_ORDER_OPENED_SUCCESS: 'SIGNALR_INCOME_RECEIVE_DERIVATIVE_ORDER_OPENED_SUCCESS',

  SIGNALR_INCOME_RECEIVE_DERIVATIVE_ORDER_CLOSED: 'SIGNALR_INCOME/derivatives-order-closed',

  SIGNALR_INCOME_RECEIVE_DERIVATIVE_POSITION_CREATED: 'SIGNALR_INCOME/derivatives-opened-position-created',
  SIGNALR_INCOME_RECEIVE_DERIVATIVE_POSITION_CREATED_SUCCESS: 'SIGNALR_INCOME_RECEIVE_DERIVATIVE_POSITION_CREATED_SUCCESS',

  SIGNALR_INCOME_RECEIVE_DERIVATIVE_POSITION_UPDATED: 'SIGNALR_INCOME/derivatives-opened-position-updated',
  SIGNALR_INCOME_RECEIVE_DERIVATIVE_POSITION_UPDATED_SUCCESS: 'SIGNALR_INCOME_RECEIVE_DERIVATIVE_POSITION_UPDATED_SUCCESS',

  SIGNALR_INCOME_RECEIVE_DERIVATIVE_CLOSED_POSITION_UPDATED: 'SIGNALR_INCOME/derivatives-closed-position-updated',
  SIGNALR_INCOME_RECEIVE_DERIVATIVE_CLOSED_POSITION_CREATED: 'SIGNALR_INCOME/derivatives-closed-position-created',

  SIGNALR_INCOME_RECEIVE_DERIVATIVE_POSITION_CLOSED: 'SIGNALR_INCOME/derivatives-opened-position-closed',
  SIGNALR_INCOME_RECEIVE_DERIVATIVE_POSITION_CLOSED_SUCCESS: 'SIGNALR_INCOME_RECEIVE_DERIVATIVE_POSITION_CLOSED_SUCCESS',

  SIGNALR_INCOME_RECEIVE_DERIVATIVE_MARK_PRICE: 'SIGNALR_INCOME/derivatives-mark-price-_receive',
  SIGNALR_INCOME_RECEIVE_DERIVATIVE_MARK_PRICE_SUCCESS: 'SIGNALR_INCOME_RECEIVE_DERIVATIVE_MARK_PRICE_SUCCESS',
  SIGNALR_INCOME_RECEIVE_DERIVATIVE_PRICE: 'SIGNALR_INCOME/derivatives-price-receiveddd',
  SIGNALR_INCOME_RECEIVE_DERIVATIVE_PRICE_SUCCESS: 'SIGNALR_INCOME_RECEIVE_DERIVATIVE_PRICE_SUCCESS',
  SIGNALR_INCOME_RECEIVE_DERIVATIVE_ORDER_BOOK_SNAPSHOT: 'SIGNALR_INCOME/derivatives-order-book-snapshot',
  SIGNALR_INCOME_RECEIVE_DERIVATIVE_ORDER_BOOK_UPDATE: 'SIGNALR_INCOME/derivatives-order-book-update',

  LOADING_GET_LATEST_DERIVATIVES_CLOSED_ORDER: 'LOADING_GET_LATEST_DERIVATIVES_CLOSED_ORDER',
  SUCCESS_GET_LATEST_DERIVATIVES_CLOSED_ORDER: 'SUCCESS_GET_LATEST_DERIVATIVES_CLOSED_ORDER',
  ERROR_GET_LATEST_DERIVATIVES_CLOSED_ORDER: 'ERROR_GET_LATEST_DERIVATIVES_CLOSED_ORDER',

  LOADING_GET_DERIVATIVIES_IN_USE_ORDERS: 'LOADING_GET_DERIVATIVIES_IN_USE_ORDERS',
  LOADING_GET_DERIVATIVIES_IN_USE_POSITIONS: 'LOADING_GET_DERIVATIVIES_IN_USE_POSITIONS',

  GET_DERIVATIVIES_IN_USE_ORDERS: 'GET_DERIVATIVIES_IN_USE_ORDERS',
  ERROR_GET_DERIVATIVIES_IN_USE_ORDERS: 'ERROR_GET_DERIVATIVIES_IN_USE_ORDERS',
  GET_DERIVATIVIES_IN_USE_POSITIONS: 'GET_DERIVATIVIES_IN_USE_POSITIONS',
  ERROR_DERIVATIVIES_IN_USE_POSITIONS: 'ERROR_DERIVATIVIES_IN_USE_POSITIONS',

  CLEAR_IN_USE_TRANSACTIONS: 'CLEAR_IN_USE_TRANSACTIONS',

  SET_DERIVATIVE_ORDER_IS_EDITING: 'SET_DERIVATIVE_ORDER_IS_EDITING',
} as const;
